import { ContentConverter } from './ContentConverter';
import { ContentTypeServerEnum } from './ContentItem';
import { convertToNavigationRestrictionWithAutoProgress } from './propertiesConverter';
import { RestrictionConverter } from './restrictionConverter';
import { QuestionHelper } from '../content/Question';
import { isSection } from '../content/itemTypeguards';
export const convertToQuestion = (questionServer, parentId) => {
    return QuestionHelper.build({
        title: questionServer.title,
        content: ContentConverter.convertToDomainModel(questionServer.content),
        restriction: convertToNavigationRestrictionWithAutoProgress(questionServer.properties),
        trackingIdentifier: questionServer.trackingIdentifier,
        audioAsset: questionServer.audioAsset,
        id: questionServer.guid,
        referenceIdentifier: questionServer.referenceIdentifier,
        parentId: parentId,
    });
};
export const convertQuestionToUpdateServerModel = (item) => {
    return {
        guid: item.id,
        title: item.title,
        content: ContentConverter.convertToServerModel(item.content),
        audioAsset: item.audioAsset,
        properties: {
            navigation: RestrictionConverter.toServerModel(item.restriction),
        },
        referenceIdentifier: item.referenceIdentifier,
    };
};
export const convertQuestionToCreateServerModel = (item, parentItem) => {
    const defaultData = {
        ...convertQuestionToUpdateServerModel(item),
        itemType: ContentTypeServerEnum.Question,
        trackingIdentifier: item.trackingIdentifier,
    };
    return isSection(parentItem)
        ? {
            ...defaultData,
            parentId: parentItem.id,
        }
        : {
            ...defaultData,
            itemId: parentItem.id,
        };
};
